<template>
  <button
      @mouseenter="isHovering = true"
      @mouseleave="isHovering = false"
      :class="['button', small ? 'button-small' : '']"
      :disabled="disabled"
      @click="onClick"
  >
    <svg :width="small ? 15 : 30" :height="small ? 12 : 24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M12 2.25C12 1.03125 12.9844 0 14.25 0H27.75C28.9688 0 30 1.03125 30 2.25V21.75C30 23.0156 28.9688 24 27.75 24H17.8594C17.9531 23.7656 18 23.5312 18 23.25V11.9062C18.8438 11.5781 19.5 10.7344 19.5 9.75V8.25C19.5 7.03125 18.4688 6 17.25 6H12V2.25ZM26.7656 16.3125C27.0469 16.0312 27.0469 15.5156 26.7656 15.2344L23.7656 12.2344C23.4844 11.9531 22.9688 11.9531 22.6875 12.2344L19.6875 15.2344C19.4062 15.5156 19.4062 16.0312 19.6875 16.3125C19.9688 16.5938 20.4844 16.5938 20.7656 16.3125L22.5 14.5781V20.25C22.5 20.6719 22.8281 21 23.25 21C23.625 21 24 20.6719 24 20.25V14.5781L25.6875 16.3125C25.9688 16.5938 26.4844 16.5938 26.7656 16.3125ZM0 8.25C0 7.875 0.328125 7.5 0.75 7.5H17.25C17.625 7.5 18 7.875 18 8.25V9.75C18 10.1719 17.625 10.5 17.25 10.5H0.75C0.328125 10.5 0 10.1719 0 9.75V8.25ZM16.5 22.5C16.5 23.3438 15.7969 24 15 24H3C2.15625 24 1.5 23.3438 1.5 22.5V12H16.5V22.5ZM6.75 15C6.32812 15 6 15.375 6 15.75C6 16.1719 6.32812 16.5 6.75 16.5H11.25C11.625 16.5 12 16.1719 12 15.75C12 15.375 11.625 15 11.25 15H6.75Z"
          fill="white"/>
    </svg>
    <span>{{ text }}</span>
    <svg v-if="!loading" :width="small ? 7.5 : 13" :height="small ? 12 : 24" viewBox="0 0 13 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M3 21C2.57812 21 2.20312 20.8594 1.92188 20.5781C1.3125 20.0156 1.3125 19.0312 1.92188 18.4688L8.34375 12L1.92188 5.57812C1.3125 5.01562 1.3125 4.03125 1.92188 3.46875C2.48438 2.85938 3.46875 2.85938 4.03125 3.46875L11.5312 10.9688C12.1406 11.5312 12.1406 12.5156 11.5312 13.0781L4.03125 20.5781C3.75 20.8594 3.375 21 3 21Z"
          fill="white"/>
    </svg>
    <loader style="height: 25px" :is-hovering="isHovering" v-if="loading"></loader>
  </button>
</template>

<style scoped>
.button {
  font-weight: 700;
  font-size: clamp(18px, 1.667vw, 23.99px);
  line-height: 160%;
  padding: 12px clamp(20px, 2.778vw, 40px);
  background: #E12A12;
  border-radius: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: 0.3s;
  border: 2px solid #E12A12;
}

.button-small{
  font-size: 18px;
  padding: 12px;
  gap: 8px;
}

.button:disabled{
  background: #6c6c6c;
  border-color: #6c6c6c;
  cursor: not-allowed;
}

.button:not(:disabled):hover {
  background-color: #fff;
  color: #E12A12;
}

.button svg path {
  transition: 0.3s;
}

.button:not(:disabled):hover svg path {
  fill: #E12A12;
}
</style>

<script>
export default {
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    text: String,
    href: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    isHovering: false,
  }),
  methods: {
    onClick: function(e){
      this.$emit('clicked', e)

      if(this.href){
        location.href = this.href;
      }
    }
  }
}
</script>
